module.exports = __webpack_public_path__ + "ee48fc3b60405a21a987be5c34283485.png";